"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
const specific_entity_1 = require("../../abstracts/specific-entity");
const config_1 = require("../../shared/config");
class Flag extends specific_entity_1.SpecificEntity {
    constructor(parentEntity, debug = false) {
        super(parentEntity.id, parentEntity, debug);
        this.BASE_URLS = {
            'PROD': 'https://backendless.nblocks.cloud',
            'STAGE': 'https://backendless-stage.nblocks.cloud',
            'DEV': 'http://localhost:3080'
        };
    }
    async evaluate(flagKey, contextData) {
        const response = await this.getHttpClient().post(`/flags/evaluate/${this.id}/${flagKey}`, contextData, { baseURL: this._getBaseUrl() });
        return response.data;
    }
    async bulkEvaluate(contextData) {
        const response = await this.getHttpClient().post(`/flags/bulkEvaluate/${this.id}`, contextData, { baseURL: this._getBaseUrl() });
        return response.data;
    }
    /**
     * Gets the base url by fetching current stage from Platform
     * @returns
     */
    _getBaseUrl() {
        return config_1.ConfigHelper.getEnvVariable("NBLOCKS_BACKENDLESS_API_URL") || this.BASE_URLS[this.getPlatformClient().stage];
    }
}
exports.Flag = Flag;
